var _rect, _path;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgIconUploadImg(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 30,
    height: 30,
    viewBox: "0 0 30 30",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 30,
    height: 30,
    rx: 5,
    fill: "#2A8DD8",
    fillOpacity: 0.1
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M10.8333 14.1667C10.0584 14.1667 9.67087 14.1667 9.35295 14.2519C8.49022 14.483 7.81635 15.1569 7.58519 16.0196C7.5 16.3375 7.5 16.725 7.5 17.5V18.5C7.5 19.9001 7.5 20.6002 7.77248 21.135C8.01217 21.6054 8.39462 21.9878 8.86502 22.2275C9.3998 22.5 10.0999 22.5 11.5 22.5H18.5C19.9001 22.5 20.6002 22.5 21.135 22.2275C21.6054 21.9878 21.9878 21.6054 22.2275 21.135C22.5 20.6002 22.5 19.9001 22.5 18.5V17.5C22.5 16.725 22.5 16.3375 22.4148 16.0196C22.1836 15.1569 21.5098 14.483 20.647 14.2519C20.3291 14.1667 19.9416 14.1667 19.1667 14.1667M18.3333 10.8333L15 7.5M15 7.5L11.6667 10.8333M15 7.5V17.5",
    stroke: "#2A8DD8",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconUploadImg);
export default __webpack_public_path__ + "static/media/icon-upload-img.14ae4f93d156d7b8614e27ee86e7c4a8.svg";
export { ForwardRef as ReactComponent };